import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  public static readonly DEFAULT_LOCALE = 'en';

  constructor(private translate: TranslateService) {}

  public get currentLocale(): string {
    return this.translate.currentLang;
  }

  public init(): Observable<any> {
    this.translate.setDefaultLang(LocalizationService.DEFAULT_LOCALE);

    return this.translate.use(LocalizationService.DEFAULT_LOCALE).pipe(first());
  }

  public instant(key: string): string {
    return this.translate.instant(key);
  }

  public get(key: string): Observable<string> {
    return this.translate.get(key);
  }
}
